// Keep this enum in this exact order !!!

export enum CollectionType {
  PRIMARY_TILESET,
  SECONDARY_TILESET,
  DENSITY,
  DETECTION,
  MEASURE
}
